var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("ContextLogin", {
        class: ["oauthCardContextLogin"],
        attrs: {
          redirectTo: _vm.redirectTo,
          context: _vm.context,
          clientType: _vm.clientType,
          completeRedirectUrl: _vm.completeRedirectUrl,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }